import React from 'react';

type IProps = {
  content: React.ReactNode;
  className?: string;
};

/** Inline content (string, number, or span) is wrapped in <p>. Block content (div, fragment, etc.) is rendered as-is to avoid invalid HTML (e.g. <p><div>). */
const isInlineContent = (content: React.ReactNode): boolean => {
  if (typeof content === 'string' || typeof content === 'number') return true;
  if (React.isValidElement(content) && content.type === 'span') return true;
  return false;
};

const Description: React.FC<IProps> = ({ className = '', content }) => (
  <div className={`change-email-modal--description ${className}`}>
    {isInlineContent(content) ? <p>{content}</p> : content}
  </div>
);

export default Description;
